module.exports = __webpack_public_path__ + "img/Distant.1602dda2.svg";